import { PageControl } from './main';

export class IndicatorAdminHelper {
    areaIcon: string;
    areaId: string;
    areaName: string;
    indicatorId: string;
    indicatorName: string;
    score: number;
    areas: string[] = [];
}

export class IndicatorSearchParams {
    search: string;
    featuredIn: string[] = [];
    area: string[] = [];
    searchQuery: string;
    areas: string[] = [];
    influencesScore: boolean;
    pageControl: PageControl = new PageControl;
    purposes?: string[] = [];
}

export class Indicator {
    name: string;
    description: string;
    icon: string;
    score: number;
    cityBenchmarkName: string;
    cityBenchmarkRegion: string;
    cityBenchmarkCountry: string;
    cityBenchmarkId: string;
    cityBenchMarkScore: number;
    areaIcon: string;
    areaId: string;
    areaName: string;
    indicatorId: string;
    indicatorName: string;
    subArea: string;
}


export class IndicatorListItem {
    areas: string[] = [];
    goal: number;
    indicatorId: string;
    influencesScore: boolean;
    name: string;
    unity: string;
    updatedAt: string;
}

export class IndicatorAdmin {
    analysis: string;
    areaId: string;
    areaImpacts: Array<{}> = [];
    areas: Array<string> = [];
    code: string;
    createdAt: string;
    description: string;
    goal: number;
    greaterBetter: boolean;
    id: string;
    influencesScore: boolean;
    name: string;
    order: number;
    reference: string;
    subArea: SubArea;
    sustainableDevelopmentGoalsIds: Array<string> = [];
    unity: string;
    updatedAt: string;
    validation: string;
}

export class SustainableDevelopmentGoal {
    color: string;
    description: string;
    iconUrl: string;
    id: string;
    name: string;
    number: number;
}

export enum SubArea {
    CRIMINALITY = "",
    INFRASTRUCTURE_AND_HUMAN_RESOURCES = "",
    DISASTER_MANAGEMENT = "",
    ECONOMY_AND_SOCIAL_CONDITIONS = "",
	PUBLIC_FINANCES = "",
    CITIZEN_PARTICIPATION = "",
    COMMUNICATION_TECHNOLOGIES = "",
    CONNECTIVITY_INFRASTRUCTURE = "",
    INNOVATION = "",
	WATER_SUPPLY = "",
    RAINWATER_MANAGEMENT = "",
    URBAN_PLANNING = "",
    LEISURE_AND_GREEN_AREA = "",
    ELECTRIC_POWER_CONSUMPTION = "",
	ELECTRICITY_INFRASTRUCTURE = "",
    AIR_POLLUTION = "",
    WATER_AND_SANITATION = "",
    SOLID_WASTE = "",
    GENERAL_INFORMATION = "",
    MORTALITY = "",
	BUSINESS_ENVIRONMENT = "",
    EASE_OF_ENTREPRENEURSHIP = "",
    EMPLOYMENT_AND_INCOME = "",
    SUSTAINABLE_MOBILITY = "",
	PUBLIC_TRANSPORTATION = "",
    ACCESS_TO_EDUCATION = "",
    SCHOOL_SURVIVAL_RATE = "",
    TEACHING_INFRASTRUCTURE = "",
    SUSTAINABILITY = "",
    ENTREPRENEURSHIP = "",
    SOCIOECONOMIC_DEVELOPMENT = "",
}